import { EIdCardOptions } from "@rentiohq/shared-frontend/dist/forms/addContact/schema.addContact.1.broker";
import { getMappedLanguages } from "@rentiohq/shared-frontend/dist/utils/location/location.utils";
import { address as addressUtils } from "@rentiohq/web-shared/dist/utils";
import {
  IFormikValues,
  IFormStep,
} from "@rentiohq/web-shared-next/dist/utils/types/form";
import { EField, IExtraData } from "./completeContact.types";
import { uiSchema } from "./schema.completeContact";

export interface IInitialContactValues {
  [EField.FirstName]: string;
  [EField.LastName]: string;
  [EField.Email]: string;
  [EField.Phone]: string;
  [EField.Address]?: string | string[];
  [EField.PlaceOfBirth]?: string | string[];
  [EField.CountryOfBirth]?: string;
  [EField.Language]: string;
  [EField.NationalRegisterNumber]?: string;
  [EField.ForeignIdentityNumber]?: string;
  [EField.DateOfBirth]?: Date;
  [EField.Nationality]?: string;
  [EField.IdType]:
    | EIdCardOptions.BelgianIdCardNumber
    | EIdCardOptions.PassportNumber;
  [EField.PrefillAddress]: "yes" | "no";
  [EField.CountryId]?: string;
}

export const getInitialValues = ({
  contact,
  prefilledAddress,
  initialType,
}: IExtraData): IInitialContactValues => {
  let address = undefined;
  if (contact?.street) {
    address = {
      street: contact.street,
      number: contact.number,
      box: contact.box,
      zip: contact.zip,
      city: contact.city,
      state: contact.state,
      country: contact.countryId,
    };
  }

  let placeOfBirth = undefined;
  if (contact?.placeOfBirth) {
    placeOfBirth = {
      city: contact.placeOfBirth,
      country: contact.countryOfBirth,
    };
  }

  return {
    [EField.FirstName]: contact?.firstname || "",
    [EField.LastName]: contact?.lastname || "",
    [EField.Email]: contact?.email || "",
    [EField.Phone]: contact?.phone || "",
    [EField.Language]: contact?.locale || getMappedLanguages()[0].id,
    [EField.NationalRegisterNumber]:
      contact?.nationalRegisterNumber || undefined,
    [EField.ForeignIdentityNumber]: contact?.foreignIdentityNumber || undefined,
    [EField.DateOfBirth]: contact?.dateOfBirth || undefined,
    [EField.Nationality]: contact?.nationality || undefined,
    [EField.IdType]:
      contact?.nationalRegisterNumber || contact?.nationality === "BE"
        ? EIdCardOptions.BelgianIdCardNumber
        : EIdCardOptions.PassportNumber,
    [EField.PrefillAddress]: prefilledAddress ? "yes" : "no",
    [EField.Address]: addressUtils.addressObjToString(address || {}),
    [EField.PlaceOfBirth]: addressUtils.addressObjToString(placeOfBirth || {}),
    [EField.CountryOfBirth]: contact?.countryOfBirth,
    [EField.CountryId]: contact?.countryId,
    ...address,
  };
};

export const completeContactSchema =
  (extraData: IExtraData) =>
  (): { formStepsSchema: IFormStep[]; initialValues: IFormikValues } => {
    const initialValues = getInitialValues(extraData);
    const formStepsSchema = [
      {
        uiSchema: uiSchema(extraData),
      },
    ];

    return { formStepsSchema, initialValues };
  };
